<template>
 <!-- <el-col :span="24"><div class="grid-content bg-purple-dark"></div></el-col> -->

 <el-row class='sticky-top' style="background-color: #fff;  "> 
    <!-- <el-col :span="24"><div class="grid-content bg-purple-dark"></div></el-col> -->
    <!-- <el-row > -->
    <!-- <el-col :span="3"><div class="grid-content bg-purple-dark"> 123 </div></el-col>  -->
      <el-col    :span="24"   class="header navbar"  >
        <div class="container" >
            <img  src="../assets/newlogo.png"   height="50px"  @click="Refresh" style="margin-right:30px;cursor:pointer; ">
            <el-menu v-if="!isPhone" text-color="#000000"  :default-active="activeIndex" class="el-menu-demo" mode="horizontal"   style=" border-bottom:none; ">
            
                <!-- <el-menu-item index="1"      @click.native="ChoosePageType1">
            
                    <router-link to="/tools"  style="  text-decoration: none;color:black;width:100%">  
                        法律工具 
                    </router-link>
                </el-menu-item> -->
                <!-- <el-menu-item v-if="!isPhone"  index="2"    @click.native="ChoosePageType2 "  >
                    <router-link to="/search_tools"  style="  text-decoration: none;color:black;width:100%">  查询与检索 </router-link>
                </el-menu-item> -->

                <el-menu-item v-if="!isPhone"  index="workbench"   @click.native="turn2head_tag('homepage')" >
                    <router-link to="/"  style="  text-decoration: none;color:black;width:100%">  工作台 </router-link>
                </el-menu-item>

                <el-menu-item v-if="!isPhone"  index="wenshu"     @click.native="turn2head_tag('wenshu')"      >
                     <!-- @click.native="Choose2Wenshu"  -->
                    <router-link to="/wenshu"  style="  text-decoration: none;color:black;width:100%">  裁判文书大数据 </router-link>
                </el-menu-item>



                <el-menu-item v-if="!isPhone"  index="lawlib"      @click.native="turn2head_tag('lawlib')"  >
                    <router-link to="/lawlib"  style="  text-decoration: none;color:black;width:100%">  法律法规库 </router-link>
                </el-menu-item>
                    

            

                <!-- <el-menu-item v-if="!isPhone"  index="4"  @click.native="ChoosePageType4">
                    
                    <router-link to="/service"  style="  text-decoration: none;color:black;width:100%"> 文件处理 </router-link>
                </el-menu-item> -->
        

                <el-menu-item v-if="!isPhone" index="71"      @click.native="turn2head_tag('community')"    >  
                      <!-- @click.native="ChoosePageType71" -->
                    <router-link to="/community"  style="  text-decoration: none;color:black;width:100%">  LawTip社区 </router-link>    
                </el-menu-item>

                <el-menu-item v-if="!isPhone" index="contract"     @click.native="turn2head_tag('contracts')"   >  
                     <!-- @click.native="Choose2Contract" -->
                    <router-link to="/contracts"  style="  text-decoration: none;color:black;width:100%">  合同模板 </router-link>    
                </el-menu-item>

            

                <el-menu-item v-if="!isPhone" index="columns"   @click.native="turn2head_tag('columns')"     > 专栏  </el-menu-item>

                <el-menu-item v-if="!isPhone" index="chatgpt"   @click.native="turn2head_tag('chatgpt')"     >  法律大模型 </el-menu-item>

  <!-- @click.native="choose2subject"  -->
                <!-- <el-menu-item v-if="!isPhone" index="oa"    @click.native="turn2head_tag('oa')"  > 律师办公管理系统  </el-menu-item>  -->
                 <!-- @click.native="choose2oa"  -->
 
    
            </el-menu>

            <el-col   v-if="!isPhone" class="header right  "  >
                <!-- hidden-md-and-down -->

                      <!-- <el-input placeholder="搜工具" v-model="search_word"  style="width:500px"     @keyup.enter.native="SearchEvent">

                            
                            <el-button slot="append"  type="primary" icon="el-icon-search" @click="SearchEvent" >搜索</el-button>
                
                        </el-input>   -->
      
                <i class="el-icon-shopping-cart-2"  v-if="$store.state.accountInfo.vip!=1" style="font-size:28px;margin-right:10px;cursor:pointer" @click="UpdateVip"></i>

                <el-badge v-if="$store.state.accountInfo.vip!=1" value="vip"  size='small'    @click.native="UpdateVip" style="position:relative; left:-26px;font-size:7px;cursor:pointer">
    
                </el-badge>
               
                <!-- <span    class="iconfont" style="color:#8590a6;font-size:26px;margin-right:24px;cursor:pointer" @click="openNoticePanel">&#xe66c;</span> -->
                <i class="el-icon-bell"  @click="openNoticePanel"  style="color:#8590a6;font-size:22px;margin-right:22px;cursor:pointer" ></i>
               
                <el-badge v-if="$store.state.islogin && $store.state.noticeInfo.newnum>0" :value="$store.state.noticeInfo.newnum" :max="10"  @click.native="openNoticePanel" style="position:relative; left:-40px;cursor:pointer">
          
                       
                </el-badge>

 
                <el-avatar v-if="!$store.state.islogin" title="登录" :src="require('@/assets/images/touxiang.png')" style="margin-right:20px;cursor:pointer" @error="errorHandler" @click.native="SignIn"  >
                    
                </el-avatar>
 
                <el-dropdown v-else  @command="handleAvatarPanel" >
                    <el-avatar  :src="loginInfo.avatarUrl" style="margin-right:20px;cursor:pointer" @error="errorHandler" >
                        <img :src="loginInfo.avatarUrl? loginInfo.avatarUrl :'https://oss.lawtip.cn/mix/public_avatar.png' "   />
                    </el-avatar>
                    <el-badge v-if="$store.state.accountInfo.vip==1"  value="V"   @click.native="UpdateVip" style="position:relative; left:-32px;font-size:10px;cursor:pointer" />


                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item  > {{$store.state.userInfo.nickName}} 

                        <el-badge v-if="$store.state.accountInfo.vip==1" style=" position:relative;left:-5px"  class="mark" value="vip" />    
                            
                        </el-dropdown-item> 
 
                        <el-dropdown-item v-if="$store.state.accountInfo.vip!=1"  @click.native="UpdateVip" >  
                            升级会员
                        </el-dropdown-item>  

                        <el-dropdown-item v-else  @click.native="UpdateVip" >  
                            会员期：{{timestampToTime($store.state.accountInfo.vip_expire)}} 
                        </el-dropdown-item> 

                        <el-dropdown-item  v-if="$store.state.accountInfo.phone && $store.state.accountInfo.phone.length==11" >  已绑定手机   </el-dropdown-item> 
                        <el-dropdown-item  v-else > 绑定手机   </el-dropdown-item> 



                        <el-dropdown-item @click.native="ChangeProfile" >修改头像昵称</el-dropdown-item> 

                        <el-dropdown-item @click.native="SignOut">退出登录</el-dropdown-item> 
                        <el-dropdown-item divided  command="mine">
                            <span class="iconfont">&#xe6e5;</span>
                            个人中心
                        </el-dropdown-item> 
                  
        

                        <el-dropdown-item  command="deposit"  >
                     
                            <span class="iconfont">&#xe71b;</span>
                            充值({{myCoins}})
                        </el-dropdown-item>  

                    </el-dropdown-menu>
                </el-dropdown>

          
            </el-col >



        </div>
            <!-- <div class="header left">
                
                <img v-if="!isPhone" src="../assets/images/newlogo.png" width="134px" height="50px"  @click="Refresh" >
                <img v-else src="../assets/images/newlogo.png" width="134px" height="50px"  @click="Refresh">
             
      

         
                <el-menu v-if="!isPhone" text-color="#000000"  :default-active="activeIndex" class="el-menu-demo" mode="horizontal"   style="height:100%;border-bottom:none">
             
                    <el-menu-item index="1"  style="height:100% "   @click.native="ChoosePageType1">
                
                        <router-link to="/tools"  style="  text-decoration: none;color:black;width:100%">  
                            法律工具 
                        </router-link>
                    </el-menu-item>
                    <el-menu-item v-if="!isPhone"  index="2"   style="height:100% "   @click.native="ChoosePageType2 "  >
                      <router-link to="/search_tools"  style="  text-decoration: none;color:black;width:100%">  查询与检索 </router-link>
                    </el-menu-item>

                    <el-menu-item v-if="!isPhone"  index="wenshu"   style="height:100% "    @click.native="Choose2Wenshu" >
                     <router-link to="/wenshu"  style="  text-decoration: none;color:black;width:100%">  裁判文书大数据 </router-link>
                    </el-menu-item>

 

                    <el-menu-item v-if="!isPhone"  index="lawlib"   style="height:100% "      >
                      <router-link to="/lawlib"  style="  text-decoration: none;color:black;width:100%">  法律法规库 </router-link>
                    </el-menu-item>
                     

              

                    <el-menu-item v-if="!isPhone"  index="4" style="height:100% " @click.native="ChoosePageType4">
                        
                        <router-link to="/service"  style="  text-decoration: none;color:black;width:100%"> 文件处理 </router-link>
                    </el-menu-item>
         

                    <el-menu-item v-if="!isPhone" index="71"   style="height:100% "    @click.native="ChoosePageType71">  
                        <router-link to="/community"  style="  text-decoration: none;color:black;width:100%">  LawTip社区 </router-link>    
                    </el-menu-item>

                    <el-menu-item v-if="!isPhone" index="contract"   style="height:100% "    @click.native="Choose2Contract">  
                        <router-link to="/contracts"  style="  text-decoration: none;color:black;width:100%">  合同模板 </router-link>    
                    </el-menu-item>

                

                    <el-menu-item v-if="!isPhone" index="columns"   @click.native="choose2subject" style="height:100% " > 专栏  </el-menu-item>

        
                </el-menu>
     

 
                
            </div> -->
          

 

        <el-dialog
            title="微信扫描二维码,在小程序中修改"
            :visible.sync="changeprofile_onoff"
            width="25%"
            :before-close="handleClose"> 
            <img src="../assets/images/changeprofile.png" alt="" style="margin:auto">
            <!-- <span>这是一段信息</span> -->
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
        </el-dialog>
            
    </el-col> 

    <!-- <el-col :span="3"><div class="grid-content bg-purple-dark"> 123 </div></el-col>  -->

    <!-- </el-row> -->
 </el-row>

</template>

<script>
    function getNum() {
        var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
            'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
            'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
            'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
            'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
            'x', 'y', 'z'];
        var nums = "";
        for (var i = 0; i < 8; i++) {
            var id = parseInt(Math.random() * 61);
            nums += chars[id];
        }
        return nums;
    }
 
    function delCookie () {  //清空所有cookie ,好像没屌用
        var keys = document.cookie.match(/[^ =;]+(?==)/g)
        if (keys) {
            for (var i = keys.length; i--;) {
            document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
            document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
            document.cookie = keys[i] + '=0;path=/;domain=ratingdog.cn;expires=' + new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
            }
        }
    }



	export default {
        name: 'Header',
        props: {
            isPhone:Boolean,
            islogin:Boolean,
            loginInfo:Object,
            myCoins:String,
            // isOnshow:Boolean,
		},
        data() {
			return {
				activeIndex: 'workbench',
                // activeIndex2: '1',
                emptyAvatar:'@/assets/images/touxiang.png',
                type:0,
                // rightOnShow:true,
                // screenWidth: '',
                // screenHeight: '',
                // SignInVisibl:false,
                userInfo:{},
                accountInfo:{},
                nickName:'',
                loginOpt:'',
                loginOptions:[{value: '选项1',label: '黄金糕'}],

                msgDialogVisible:false,
                changeprofile_onoff:false,

			}
        },
        mounted() {

            // console.log("$store.state.islogin:",)
          
            if(this.$root.islogin){
                // window.console.log('header 已登录')
                // window.console.log('this.$root.userInfo：',this.$root.userInfo)

                this.userInfo=this.$root.userInfo
                this.accountInfo=this.$root.accountInfo
                this.loginInfo={userInfo:{}}
                this.loginInfo.userInfo=this.$root.userInfo

                // console.log("this.userInfo:",this.userInfo)

            }



            // this.screenWidth = document.body.clientWidth;
            // this.screenHeight = document.body.clientHeight;
            // window.onresize = () => {
            //     return (() => {
            //         window.console.log('document.body.clientWidth:',document.body.clientWidth)
            //         window.console.log('document.body.clientHeight:',document.body.clientHeight)
                   
            //         this.screenWidth = document.body.clientWidth;
            //         this.screenHeight = document.body.clientHeight;
            //         if (document.body.clientWidth<=1100){
            //             this.rightOnShow=false
            //         }else{
            //              this.rightOnShow=true
            //         }

            //     })();
            // };
        },
        methods: {
            handleClose(){
                this.changeprofile_onoff=false
            },
            openNoticePanel(){
                this.$emit('ChangePanelVisible','notice'); 

            },
            openChatPanel(){
                this.$emit('ChangePanelVisible','msg'); 
            },

            handleAvatarPanel(command){
                this.$emit('ChangePanelVisible',command); 

            },
            handleSelect(key, keyPath) {
               window.console.log( key);
               window.console.log( keyPath);
               this.type=key
               window.console.log('this.type:',this.type);
               this.$emit('ChangeFunctionBox',key); 
            },
            ChoosePageType1(){
                // var timestamp = (new Date()).valueOf();
                // window.console.log('timestamp:',timestamp)
                // let key='1.'+timestamp
                // this.$emit('ChangeFunctionBox',key); 
                // window.console.log(this.$route.name)
             
                if(this.$route.name!='tools'){
                    this.$router.push({name:"tools"})
                }

                // this.$router.push({name:"tools"})
      
            },
            ChoosePageType2(){
                // var timestamp = (new Date()).valueOf();
                // window.console.log('timestamp:',timestamp)
                // let key='2.'+timestamp
                // this.$emit('ChangeFunctionBox',key); 

                if(this.$route.name!='search_tools'){
                    this.$router.push({name:"search_tools"})
                }

                // this.$router.push({name:"search_tools"})
      
            },

            // ModifyMyArticle(){
            //     this.$emit('ChangeFunctionBox',key); 
            // },
            ChoosePageType3(){
                var timestamp = (new Date()).valueOf();
                window.console.log('timestamp:',timestamp)
                let key='3.'+timestamp
                this.$emit('ChangeFunctionBox',key);  
      
            },
            ChoosePageType4(){
                // var timestamp = (new Date()).valueOf();
                // window.console.log('timestamp:',timestamp)
                // let key='4.'+timestamp
                // this.$emit('ChangeFunctionBox',key); 

                if(this.$route.name!='service'){
    
                    this.$router.push({name:"service"})
                }
      
            },
            ChoosePageType5(){
                var timestamp = (new Date()).valueOf();
                window.console.log('timestamp:',timestamp)
                let key='5.'+timestamp
                this.$emit('ChangeFunctionBox',key); 
      
            },           
            ChoosePageType6(){
                var timestamp = (new Date()).valueOf();
                window.console.log('timestamp:',timestamp)
                let key='6.'+timestamp
                this.$emit('ChangeFunctionBox',key); 
      
            },

            Choose2Contract(){
                this.$emit('ChangeFunctionBox','change2home'); 
                this.$router.push({name:"contracts"})
            },

            choose2subject(){
                this.$emit('ChangeFunctionBox','change2home'); 
                this.$router.push({name:"columns"})
            },
            choose2oa(){
                // this.$router.push({name:"workbench"})
                // this.$emit('change2oa',key); 
                this.$emit('ChangeFunctionBox','change2oa');  


            },

            turn2head_tag(tag){
                if(tag=='oa'){
                    // this.choose2oa()
                    
                    // this.$router.push({name:"oa_workbench"})
                    this.$router.push({name:"oa"})

                }else{
                    this.$emit('ChangeFunctionBox','change2home'); 
                    if(tag=='homepage'){
                        this.$router.push({name:"index"})
                    }else if(tag=='wenshu'){
                        this.$router.push({name:"wenshu"})
                    }else if(tag=='lawlib'){
                        this.$router.push({name:"lawlib"})
                    }else if(tag=='contracts'){
                        this.$router.push({name:"contracts"})
                    }else if(tag=='community'){
                        this.$router.push({name:"community"})
                    }else if(tag=='columns'){
                        this.$router.push({name:"columns"})
                    } else if(tag=='chatgpt'){
                        window.open('https://gpt.lawtip.cn','new')
                        // window.open('https://gpt.lawtip.cn','_self')
                    } 



                     

                     


                     
 
                }

            },

             

            choose2pdf(){
                this.$router.push({name:"pdf"})
            },

           

            Choose2legalpaper(){
                this.$router.push({name:"legalpaper"})
            },
            Choose2Wenshu(){
                this.$router.push({name:"wenshu"})

            },
            ChoosePageType71(){
                // var timestamp = (new Date()).valueOf();
                // window.console.log('timestamp:',timestamp)
                // let key='71'
                // this.$emit('ChangeFunctionBox',key); 

                // this.$router.push({name:"community"})
                this.$emit('ChangeFunctionBox','change2home'); 
                if(this.$route.name!='community'){
                    
                    this.$router.push({name:"community"})
                }

                // if(this.$route.name!='community'){
                //     window.console.log('fuck')

                //     this.$router.push({name:"community"})
                // }else{
                //     return
                // }
      
            },
            Refresh(){
                window.console.log('refresh')
                window.open('/',"_self")

                // this.$router.push('/Home')
                // location.reload();
            },
            errorHandler() {
                console.log('login_errorHandler')
                // this.loginInfo.avatarUrl='https://oss.lawtip.cn/mix/public_avatar.png'
                return true
            },
            SignIn(){
                window.console.log('SignIn')
                // this.SignInVisibl=true 
                let num= getNum()
                var nowurl = window.location.href;
                let target=window.btoa(nowurl)
                let state=num+'(redirect)'+target
                // let url='https://open.weixin.qq.com/connect/qrconnect?appid=wxe00435b975483ad0&redirect_uri=http%3a%2f%2fwww.lawtip.cn%2fPHPserver%2flawtipLogin.php&response_type=code&scope=snsapi_login&state='+num+'#wechat_redirect'
                let url='https://open.weixin.qq.com/connect/qrconnect?appid=wxe00435b975483ad0&redirect_uri=http%3a%2f%2fwww.lawtip.cn%2flogin&response_type=code&scope=snsapi_login&state='+state+'#wechat_redirect'
                
                // sessionStorage.setItem("login", "yes");
                localStorage.setItem("loginStatus", num);
                window.open(url,"_self") 

 
                // window.open('http://www.lawtip.cn/wenshuDetail.html?'+timestamp, '_blank')

            },

            SignOut(){
                var that=this
                window.console.log('SignOut')
                delCookie()
                this.$root.islogin=false
                this.islogin=false
                // sessionStorage.setItem("isLogin", 0);
                sessionStorage.removeItem("isLogin");
                sessionStorage.removeItem("userInfo");
                sessionStorage.removeItem("accountInfo");
                that.$store.commit('getUserInfo',{} )
                that.$store.commit('ChangeLoginStatus',false)
                // this.$notify({
                //     title: '成功',
                //     message: '成功退出登录',
                //     type: 'success'
                // });
                // https://api.lawtip.cn/sign_out
                //  '../PHPserver/login/SignOut.php'
                this.axios.get(this.$root.rootUrl+ 'sign_out',{
                // params: {
                //     timestamp:timestamp
                // }
                }).then(function (res) { 
                    if(res.status==200){
                        window.console.log(res.data)
                        let result=res.data
                        if(result.status=='ok'){
                            // that.$root.userInfo=result.userInfo;
                            // that.$root.accountInfo=result.accountInfo;
                            that.$root.islogin=false;		
                            that.$store.commit('ChangeLoginStatus',false)
                            sessionStorage.setItem("isLogin", false);
                            that.islogin=false
                            that.userInfo.avatarUrl='@/assets/images/touxiang.png'
                            window.open('/',"_self")
                        }        


                    }

                }).catch(function (error) {
                    window.console.log(error);
                });

                // 清除全局变量

                that.$root.userInfo={}
                that.$root.accountInfo={}
                that.$root.myColumnSub=''
                that.$root.notice={ newMsg:0,newNotice:0}

                localStorage.clear()
                sessionStorage.clear()





                

            },



            ShowOptions(){
                window.console.log("ShowOptions occur")
            },


            openMsgPanel(){
                this.msgDialogVisible=true
            },

            ChangeProfile(){
                this.changeprofile_onoff=true
            },


            UpdateVip(){
                // this.$router.push({path:'/bevip'})
                window.open('https://www.lawtip.cn/pages/vip')
            },
            timestampToTime(timestamp) {
                if(!timestamp){
                  return '无限期'
                }
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate() + '';
                // var h = date.getHours() + ':';   //
                // var m = date.getMinutes() + ':';//
                // var s = date.getSeconds();//
                if (M.length==1){
                    M='0' +M
                }
                if (D.length==1){
                    D='0' +D
                }
                return Y + M + D ;  //+ h + m + s
            },


 

      
            



          


             

        }
	}
	
</script>

<style>
/* .el-menu{
    color:black;
 
} */

 

.el-menu-demo{
    width:100%;
    border-bottom:none;
    
        white-space: nowrap;
    overflow: hidden;
    /* overflow-x: scroll;  */
    height: 60px;
    /* border:1px solid #b86262 ;  */
    display: flex;
    flex-direction: row;
 
    /* border:1px solid #b86262 ; */

    /* overflow-x: scroll; */
} 
.el-menu-demo2{
    width:100%;
    /* flex-start:right; */
    border:1px solid #b86262 ;
}
.el-menu-sub{margin-left: 50px;}

.header{
    /* height: 55px; */
    height: 60px;
    /* max-height: 110px; */
    /* width:100%; */
    /* border :1px solid #cf1a1a ; */
 
    display: flex;
    flex-direction: row;
 
    color:black;
    align-items: center;
    background-color: #fff;
    /* background: var(--navbar-bg); */
     
    /* padding: 0; */
    flex-flow: row nowrap;
    justify-content: flex-start; 

    
}
.header a{
    color:black;
    text-decoration: none;
}

.header.left{
    height: 100%;
    /* width:70%; */
    width:100%;
    /* border:1px solid #50b66f ; */
 
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 7px;

    /* overflow-x: scroll; */
    /* height: 60px; */
 
}
.header.left img{
    cursor: pointer;
}

.header.right{
 
    height: 100%;
    width:20%; 
 
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    /* border: 1px solid #ad3131;   */
    /* border-bottom: none; */

}

/* .hearder.right el-dropdown-item{
    border:1px solid #ad2ace ; 
    line-height: 100%;

} */


  .head_operation{
    width:40%;
    display: flex;
    flex-direction: row;
    /* border: 1px solid #ad3131;  */
    justify-content: flex-end;
    align-items:center;
    height: 100%;
    font-size:24px;
    padding-right: 15px;
  }



  .head_operation i{
    margin-left:50px;
    cursor: pointer;
  }

</style>
